
import { FormDatePicker } from "components/form/FormDatePicker/FormDatePicker";
import { FormField } from "components/form/FormField/FormField";

import style from "../CervicalCheck.module.css";

export const PatientDetails = ({ form, today }) => {
  return (
    <>
      <h2
        style={{
          fontSize: "20px",
          lineHeight: "32px",
        }}
      >
        Patient Details
      </h2>
      <div className={style.inputGroupGrid}>
        <FormField name="personalPublicServiceNumber">
          <label className={style.addLetterFormLabel}>
            Personal public service number
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("personalPublicServiceNumber")}
            />
          </div>
        </FormField>
        <FormField name="cspId">
          <label className={style.addLetterFormLabel}>CSP ID</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("cspId")}
            />
          </div>
        </FormField>
      </div>
      <div className={style.inputGroupGrid}>
        <FormField name="hospitalNumber">
          <label className={style.addLetterFormLabel}>Hospital Number</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("hospitalNumber")}
            />
          </div>
        </FormField>
        <FormField name="contactNumber">
          <label className={style.addLetterFormLabel}>
            Contact Telephone Number
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("contactNumber")}
            />
          </div>
        </FormField>
      </div>
      <div className={style.inputGroupGrid3}>
        <FormField name="firstName">
          <label className={style.addLetterFormLabel}>First Name</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("firstName")}
            />
          </div>
        </FormField>
        <FormField name="middleName">
          <label className={style.addLetterFormLabel}>Middle Name</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("middleName")}
            />
          </div>
        </FormField>
        <FormField name="surname">
          <label className={style.addLetterFormLabel}>Surname</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("surname")}
            />
          </div>
        </FormField>
      </div>
      <div className={style.inputGroupGrid3}>
        <FormField name="surnameAtBirth">
          <label className={style.addLetterFormLabel}>Surname at Birth</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("surnameAtBirth")}
            />
          </div>
        </FormField>
        <FormField name="dateOfBirth">
          <label className={style.addLetterFormLabel}>Date of Birth</label>
          <div className={style.addPregnancyDatePickerWrapper}>
            <FormDatePicker
                form={form}
                name="dateOfBirth"
                emptyValue={today}
              />
          </div>
        </FormField>
        <FormField name="mothersMaidenName">
          <label className={style.addLetterFormLabel}>
            Mother's Maiden Name
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("mothersMaidenName")}
            />
          </div>
        </FormField>
      </div>
      <div className={style.inputGroupGrid3}>
        <div style={{ gridColumn: "span 2" }}>
          <FormField name="address">
            <label className={style.addLetterFormLabel}>Address</label>
            <div>
              <input
                type="text"
                className="form-control"
                {...form.register("address")}
              />
            </div>
          </FormField>
        </div>
        <FormField name="mothersMaidenName">
          <label className={style.addLetterFormLabel}>Eircode</label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("eircode")}
            />
          </div>
        </FormField>
      </div>
    </>
  );
};
